import { WEB_SDK_SOURCE } from '../constants';

export interface FrameMessagePaymentInfo {
    lang: string; // 'ru'
    template_tag: string; // 'desktop/form'
    purchase_token: string; // 'd71bbe99332c08e0c4bc9c1965e82d3b'

    uid: string; // '88999287'
    user_email: string; // 'trust-hermione@fake.com
    currency: string; // 'RUB'
    amount: string; // '1750.00'

    card_id: string; // '6f437c99856716f1877d8422'
    masked_pan: string; // '510000****3057'
    cardholder: string; // 'CARD HOLDER'

    payment_method: string; // 'card'
    payment_method_full: string; // 'card-x6f437c99856716f1877d8422'
    payment_timeout: string; // '1200'
    balance_service_id: number; // 116
    terminal_id: number; // 96000101
    transaction_id: string; // 'v8jq9ulxjo8jbvarh52m'
    payment_id: string; // '5eba6242b63de628ab38d4e1'
    approval_code: string; // '245219'
    rrn: string; // '910502'

    is_binding_payment: boolean; // false
    binding_result?: string; // 'binding_error'

    status: string; // 'success'
    status_desc: string; // 'paid ok'
    payment_type: string; // 'common_payment'
    fiscal_status: string; // 'inprogress'
    bound_to: string; // 'trust'

    start_dt: string; // '2020-05-12T08:46:02.719000'
    payment_dt: string; // '2020-05-12T08:45:54.175000'
    payment_result_dt: string; // '2020-05-12T11:46:21'
    paysys_sent_ts: string; // '2020-05-12T08:46:21.331000'
    paysys_ready_ts: string; // '2020-05-12T08:46:20.378000'
}

export interface FrameMessageFormattedPaymentMethod {
    id: string;
    type: 'card' | 'sbp_token' | 'sbp_token_v2' | 'click_wallet' | 'mbank_account';
    [Key: string]: unknown;
}

export interface FrameMessageAppleToken {
    type: 'apple_token';
    tokenId: string;
}

export interface FrameMessageGoogleToken {
    type: 'google_token';
    tokenId: string;
}

export interface FrameMessageTdsSuccessStatus {
    type: FrameMessageType.tdsSuccess;
}

export enum FrameOutMessageType {
    callAction = 'call_action',
}

export enum FrameMessageType {
    success = 'success',
    error = 'error',
    abort = 'abort',
    resize = 'resize',
    discount = 'discount',
    formReady = 'form-ready',
    formStatus = 'form-status',
    formSubmit = 'form-submit',
    authStart = 'auth-start',
    authEnd = 'auth-end',
    authV2Start = 'auth-v2-start',
    authV2End = 'auth-v2-end',
    challengeV2Start = 'challenge-v2-start',
    challengeV2End = 'challenge-v2-end',
    tdsStatus = '3ds-status',
    tdsStarted = '3ds-started',
    tdsSuccess = '3ds-success',
    tdsFailure = '3ds-failure',
    initCheckout = 'init-checkout',
    formInit = 'form-init',
    paymentComplete = 'payment-complete',
    paymentFail = 'payment-fail',
    paymentTimeout = 'payment-timeout',
    paymentCancel = 'payment-cancel',
    paymentPreview = 'payment-preview',
    paymentLoaded = 'payment-loaded',
    sbpBankSelected = 'sbp-bank-selected',
    sbpStart = 'sbp-start',
    onResize = 'on_resize',
    callActionResponse = 'call_action_response',
    escPressed = 'esc_pressed',
    trustChallengeStart = 'trust-challenge-start',
    trustChallengeEnd = 'trust-challenge-end',
    otpChallengeStart = 'otp-challenge-start',
    otpChallengeEnd = 'otp-challenge-end',
    otpStatus = 'otp-status',
    reload = 'reload',
    external3ds = 'external-3ds',
    tokenizeComplete = 'tokenize-complete',
    tokenizeFail = 'tokenize-fail',
    requestOpenUrl = 'request-open-url',
}

export interface FrameMessageSuccess {
    type: FrameMessageType.success;
    payment?: FrameMessagePaymentInfo | FrameMessageFormattedPaymentMethod;
    cardId?: string;
    tokenId?: string;
    source?: string;
}

export interface PaymentMethodDescriptors {
    pmd: string;
    psd?: string;
}

export interface FrameMessageTokenizeComplete {
    type: FrameMessageType.tokenizeComplete;
    descriptors: PaymentMethodDescriptors;
}

export interface FrameMessageTokenizeFail {
    type: FrameMessageType.tokenizeFail;
}

export interface FrameMessageRequestOpenUrl {
    type: FrameMessageType.requestOpenUrl;
    url: string;
}

export interface FrameMessageError {
    type: FrameMessageType.error;
    reason: string;
}

export enum FrameMessageAbortReason {
    user = 'user',
    timeout = 'timeout',
}

export interface FrameMessageAbort {
    type: FrameMessageType.abort;
    reason: FrameMessageAbortReason;
}

export interface FrameMessageResizeSize {
    width?: string;
    height?: string;
}

export interface FrameMessageResize {
    type: FrameMessageType.resize;
    size: FrameMessageResizeSize;
}

export interface FrameMessageEscPressed {
    type: FrameMessageType.escPressed;
}

export interface FrameMessageDiscountData {
    amount: string;
    originalAmount: string;
    discounts: string;
    promocode: string;
}

export interface FrameMessageDiscount {
    type: FrameMessageType.discount;
    data: FrameMessageDiscountData;
}

export interface FrameMessageFormInit {
    type: FrameMessageType.formInit;
}

export interface FrameMessageFormReady {
    type: FrameMessageType.formReady;
}

export interface FrameMessageFormStatusData {
    canSubmit: boolean;
    cardSystem?: string;
}

export interface FrameMessageFormStatus {
    type: FrameMessageType.formReady;
    data: FrameMessageFormStatusData;
}

export interface FrameMessageFormSubmit {
    type: FrameMessageType.formSubmit;
}

export interface FrameMessageAuthStart {
    type: FrameMessageType.authStart;
}

export interface FrameMessageAuthEnd {
    type: FrameMessageType.authEnd;
}

export interface FrameMessageAuthV2Start {
    type: FrameMessageType.authV2Start;
}

export interface FrameMessageAuthV2End {
    type: FrameMessageType.authV2End;
}

export interface FrameMessageChallengeV2Start {
    type: FrameMessageType.challengeV2Start;
}

export interface FrameMessageChallengeV2End {
    type: FrameMessageType.challengeV2End;
}

export interface FrameMessageOtpChallengeStart {
    type: FrameMessageType.otpChallengeStart;
}

export interface FrameMessageOtpChallengeEndData {
    success: boolean;
}

export interface FrameMessageOtpChallengeEnd {
    type: FrameMessageType.otpChallengeEnd;
    data: FrameMessageOtpChallengeEndData;
}

export interface FrameMessageOtpStatusData {
    status: 'success' | 'error';
}

export interface FrameMessageOtpStatus {
    type: FrameMessageType.otpStatus;
    data: FrameMessageOtpStatusData;
}

export interface FrameMessageTrustChallengeStart {
    type: FrameMessageType.trustChallengeStart;
}

export interface FrameMessageTrustChallengeEndData {
    success: boolean;
}

export interface FrameMessageTrustChallengEnd {
    type: FrameMessageType.trustChallengeEnd;
    data: FrameMessageTrustChallengeEndData;
}

export interface FrameMessageTdsStatus {
    type: FrameMessageType.tdsStatus;
    data: FrameMessageType.tdsStarted | FrameMessageType.tdsSuccess | FrameMessageType.tdsFailure;
}

export interface FrameMessagePaymentLoaded {
    type: FrameMessageType.paymentLoaded;
}

export interface FrameMessageSbpStart {
    type: FrameMessageType.sbpStart;
}

export interface FrameMessageSbpBankSelected {
    type: FrameMessageType.sbpBankSelected;
    data: string;
}

interface CallActionResponseBindApplePay {
    paymentMethodId: string;
}

interface CallActionResponsePayApplePay {}

export type CallActionResponseActionData = CallActionResponseBindApplePay | CallActionResponsePayApplePay;

export interface CallActionResponseData {
    actionId: string;
    actionData: CallActionResponseActionData;
}

export interface FrameMessageCallActionResponse {
    type: FrameMessageType.callActionResponse;
    data: CallActionResponseData;
}

export interface FrameMessageReload {
    type: FrameMessageType.reload;
}

/**
 * Defines the method for opening 3DS authentication challenge
 * top - open the challenge in the current window or WebView
 * universal_link - open the challenge in the new tab
 */
export type NavigationMode = 'top' | 'universal_link';

export interface External3dsData {
    navigationMode: NavigationMode;
    redirectUrl: string;
}

/**
 * Message indicating the need to open 3ds challege
 * outside payment form
 */
export interface FrameMessageExternal3ds {
    type: FrameMessageType.external3ds;
    data: External3dsData;
}

export type FrameMessageBase =
    | FrameMessageSuccess
    | FrameMessageError
    | FrameMessageAbort
    | FrameMessageResize
    | FrameMessageFormReady
    | FrameMessageFormStatus
    | FrameMessageFormSubmit
    | FrameMessageAuthStart
    | FrameMessageAuthEnd
    | FrameMessageFormInit
    | FrameMessageCallActionResponse
    | FrameMessageEscPressed;

export type FrameMessageV1 =
    | FrameMessageBase
    | FrameMessageDiscount
    | FrameMessagePaymentLoaded
    | FrameMessageSbpStart
    | FrameMessageSbpBankSelected
    | FrameMessageTrustChallengeStart
    | FrameMessageTrustChallengEnd
    | FrameMessageExternal3ds;

export type FrameMessageV2 =
    | FrameMessageBase
    | FrameMessageReload
    | FrameMessageTokenizeComplete
    | FrameMessageTokenizeFail
    | FrameMessageRequestOpenUrl;

export type FrameMessageListener = (message: FrameMessageV1 | FrameMessageV2) => void;

export enum FrameApplePayIncomingMessageType {
    start = 'start_apple_pay',
}

/**
 * Типы исходящих сообщений в фрейм оплаты
 */
export enum FrameApplePayOutgoingMessageType {
    success = 'apple_pay_success',
    failure = 'apple_pay_failure',
    cancel = 'apple_pay_cancel',
}

export interface CommonFrameApplePayMessage {
    source: typeof WEB_SDK_SOURCE;
}

export interface FrameStartApplePayMessageData {
    request: ApplePayJS.ApplePayPaymentRequest;
    merchantId: string;
    purchaseToken: string;
}

export interface FrameStartApplePayMessage extends CommonFrameApplePayMessage {
    type: FrameApplePayIncomingMessageType.start;
    data: FrameStartApplePayMessageData;
}

export interface FrameApplePaySuccessMessage extends CommonFrameApplePayMessage {
    type: FrameApplePayOutgoingMessageType.success;
    data: unknown;
}
